import { NavLink, useLocation } from 'react-router-dom';
import { Home, PlusCircle, User, Users, Settings } from 'lucide-react';
import { motion } from 'framer-motion';

const navItems = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/log', icon: PlusCircle, label: 'Log' },
  { path: '/dashboard/personal', icon: User, label: 'Personal' },
  { path: '/dashboard/shared', icon: Users, label: 'Shared' },
  { path: '/settings', icon: Settings, label: 'Settings' }
];

export default function BottomNav() {
  const location = useLocation();
  const isOnboarding = location.pathname.includes('/onboarding');
  
  if (isOnboarding) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/90 backdrop-blur-lg border-t border-border safe-area-bottom">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `flex flex-col items-center justify-center flex-1 h-full touch-target transition-colors ${
                  isActive ? 'text-primary' : 'text-muted'
                }`
              }
            >
              <motion.div
                whileTap={{ scale: 0.9 }}
                transition={{ duration: 0.1 }}
              >
                <item.icon size={24} strokeWidth={isActive ? 2.5 : 2} />
              </motion.div>
              <span className="text-xs mt-1 font-medium">{item.label}</span>
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="absolute bottom-0 w-12 h-0.5 bg-primary rounded-full"
                  transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
